<script lang="ts" setup>
defineProps<Props>()

interface Props {
  title?: string
}
</script>

<template>
  <div class="border-b">
    <span v-if="title" class="block text-xs font-semibold py-1 text-neutral-500">{{ title }}</span>
  </div>
</template>
